<template>
  <div ref="gantt" id="id" class="gantt-chart-container">
    <div  class="graph-container" ref="graphContainer">
      <div class="resize-handle__icon" ref="resizeHandle">
        <span class="futureload">Future Load</span>
      </div>
      <EmbeddedFutureLoadGraph ref="futureLoad" id="0" :waitForLoad="true" />
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars

//New imports

import "sweetalert2/dist/sweetalert2.min.css";
import axios from "axios";
import { PipelineHandler } from "@/pipeline/pipelineHandler.js";
import { ButtonHandler } from "@/pipeline/buttonHandler.js";
import { NetworkHandler } from "@/pipeline/networkHandler.js";
import EmbeddedFutureLoadGraph from "@/components/graphs/EmbeddedFutureLoadGraph.vue";

export default {
  name: "CustomGanttv2",
  components: { EmbeddedFutureLoadGraph },
  data: () => ({
    minSize: 340,
    showEmbeddedGraph: false,
    mountedGraph: false,
  }),

  methods: {
    pressedButton(buttonID) {
      this.$store.state.buttonHandler.pressedButton(buttonID);
    },
    //To reset the size after rescaling
    redraw() {
      //No need if we're not in the pipeline page
      if (this.$route.name != "Pipeline") {
        return;
      }
      var parentDiv = document.querySelector(".gantt-chart-container");
      this.$store.state.visualiser.updateSVGSize(parentDiv.clientWidth, parentDiv.clientHeight);

      this.$store.state.visualiser.updateCulling();
    },

    setUpResizeHandle() {

      if(this.$store.state.ganttRefs.gantt == null){
        return;
      }
      var el = this.$store.state.ganttRefs.graphContainer;
      var self = this;
      function resize(e) {
        var newHeight = document.body.scrollHeight - e.clientY;

        newHeight = Math.min(newHeight, self.$store.state.ganttRefs.gantt.clientHeight - 100);
        var dist = self.minSize - newHeight;

        if (newHeight > 700) {
          newHeight = 700;
        }

        if (newHeight <= self.minSize) {
          newHeight = self.minSize;
        }
        if (dist > 0) {
          el.style.bottom = -dist + "px";
        }

        if (dist > self.minSize) {
          el.style.bottom = -self.minSize + "px";
        }
        el.style.height = newHeight + "px";
        //  console.log(e.clientY)

        if (self.$store.state.ganttRefs.futureLoad.resizeFunction != null) {
          self.$store.state.ganttRefs.futureLoad.resizeFunction();
        }
      }

      function windowResize() {
        if(self.$store.state.ganttRefs.gantt == null){
          return;
        }

        var height = self.$store.state.ganttRefs.gantt.clientHeight;
        var graphheight = self.$store.state.ganttRefs.graphContainer.clientHeight;

        if (height < graphheight + 200) {
          var newHeight = height - 200;
          var dist = self.minSize - newHeight;
          if (newHeight < self.minSize) {
            newHeight = self.minSize;
          }
          self.$store.state.ganttRefs.graphContainer.style.height = newHeight + "px";

          if (self.$store.state.ganttRefs.futureLoad.resizeFunction != null) {
            self.$store.state.ganttRefs.futureLoad.resizeFunction();
          }

          if (dist > 0) {
            var newBottom = -dist;

            if (newBottom <= parseFloat(self.$store.state.ganttRefs.graphContainer.style.bottom)) el.style.bottom = -dist + "px";
          }

          if (dist > self.minSize) {
            el.style.bottom = -self.minSize + "px";
          }
        }
      }

      window.addEventListener("resize", windowResize);

      this.$store.state.ganttRefs.resizeHandle.addEventListener(
        "mousedown",
        (e) => {
          el.style.transition = "initial";
          document.addEventListener("mousemove", resize, false);
        },
        false
      );

      document.addEventListener(
        "mouseup",
        () => {
          el.style.transition = "";
          document.removeEventListener("mousemove", resize, false);
        },
        false
      );
      self.$store.state.ganttRefs.graphContainer.style.bottom = 0 + "px";
      windowResize();

      var startSize = Math.min(self.minSize, self.$store.state.ganttRefs.gantt.clientHeight - 100);
    },
    setupRedraw() {
      // Draw for the first time to initialize.
      this.redraw();

      window.addEventListener("resize", this.redraw);

      //setInterval(this.redraw, 100);
    },

    setupGraph() {
      this.showEmbeddedGraph = this.$store.state.simulator.params.allowPortfolioPlanning;
      if(this.showEmbeddedGraph){
      this.$store.state.ganttRefs.graphContainer.style.visibility='visible';
        }
      else{
        this.$store.state.ganttRefs.graphContainer.style.visibility='hidden';
        return;
      }
      //Allow time for rendering
      this.$nextTick(() => {

        if(this.$store.state.ganttRefs.gantt == null || this.mountedGraph){
          return;
        }
        this.mountedGraph = true;

        this.setUpResizeHandle();
        this.$store.state.futureLoadGraph = this.$store.state.ganttRefs.futureLoad;
        this.$store.state.futureLoadGraph.reset(true);
      });
    },
    init(initSim) {
      if (this.$store.state.pipelineHandler == null) {
        this.$store.state.pipelineHandler = new PipelineHandler(this);
      }
      if (this.$store.state.buttonHandler == null) {
        this.$store.state.buttonHandler = new ButtonHandler(this);
      }
      if (this.$store.state.networkHandler == null) {
        this.$store.state.networkHandler = new NetworkHandler(this);
      }

      this.$store.state.pipelineHandler.init(initSim);
    },
  },
  mounted: function () {
    this.$store.state.ganttRefs = this.$refs
    this.$nextTick(function () {
      this.init(this.$store.state.Simulations[0]);
      this.setupRedraw();
      this.setupGraph();

      //Route to the graphs
      //this.$router.push("graphs");
    });

  },
};
</script>

<style>
.tooltip {
  position: absolute;
  text-align: center;
  width: 400px;
  height: 200px;
  padding: 2px;
  font: 12px sans-serif;
  background-color: lightsteelblue;
  border: 0px;
  border-radius: 8px;
  pointer-events: none;
}
</style>
<style scoped>
.gantt-chart-container {
  height: calc(100% - 48px);
  width: 100%;
  position: absolute;
  top: var(--topbar-size);
  background-color: "white";
  overflow: none;
}

.load-graph {
  background-color: white;
  position: absolute;
  height: 600px;
  bottom: 0;
  width: 100%;
}

.resize-handle__icon {
  width: 150px;
  height: 32px;
  border-top: 2px solid #949494;
  border-right: 2px solid #949494;
  border-left: 2px solid #949494;
  z-index: 1000;

  position: absolute;
  top: -30px;
  border-radius: 5px 5px 0 0;

  background-color: #fdfdfd;
}
.futureload {
  position: absolute;
  top: 2px;
  left: 20px;
  font-size: 15px;
  font-weight: bold;
  color: #4a4a4a;
}
.resize-handle {
  background-color: black;
  width: 100%;
  height: 10px;

  position: absolute;
  top: -10;
  z-index: 100;
}

.graph-container {
  position: absolute;
  width: calc(100% - var(--resource-bar-width));
  left: var(--resource-bar-width);
  height: 400px;
  bottom: 0;
  background-color: white;
  opacity: 1;
}
</style>

<style></style>
